import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DxTextBoxComponent, DxTextBoxModule } from 'devextreme-angular';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SubCompanyRequestsService } from '../../../services/sub-company-requests.service';
import { SelectedCompanyService } from '../../../selected-company/selected-company.service';
import { SubCompanyRequestsCreateDto } from '../../../interfaces/subcompany-create-requests.interface';
import { showErrorSwal } from '@asamco/utils';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-subcompany-creation-request-modal',
	standalone: true,
	imports: [
		CommonModule,
		DxTextBoxModule,
		FormsModule, ReactiveFormsModule
	],
	templateUrl: './subcompany-creation-request-modal.component.html',
	styleUrl: './subcompany-creation-request-modal.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubcompanyCreationRequestModalComponent {

	/**
	 *
	 */
	constructor(private subCompanyRequestsService: SubCompanyRequestsService, private selectedCompanyService: SelectedCompanyService) {

	}

	subcompanyCreateForm = new FormGroup({
		name: new FormControl('', [Validators.required]),
		email: new FormControl('', [Validators.required, Validators.email]),
	});

	public showDialog$: Subject<boolean> = new BehaviorSubject<boolean>(false);

	public show() {
		this.showDialog$.next(true);
	}

	public cancel(): void {
		this.showDialog$.next(false);
	}

	public sendRequest(): void {
		const subCompanyRequestsCreateDto: SubCompanyRequestsCreateDto = {
			companyId: this.selectedCompanyService.getSelectedCompanyID(), //Allows us to impersonate if we need to..
			newSubCompanyName: this.subcompanyCreateForm.value.name,
			userEmail: this.subcompanyCreateForm.value.email,
		};

		this.subCompanyRequestsService.createNewSubCompanyRequest(subCompanyRequestsCreateDto).subscribe({
			next: () => { Swal.fire('Success', 'Request has been sent', 'success') },
			error: (error) => showErrorSwal(error),
			complete: () => { this.showDialog$.next(false);  }
		})
	}
}
